import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { recruitNowWebhookQueryKeys } from "./queryKeys";
import type { PaginatedWebhookRegistrationsResponse } from "./useClientWebhookRegistrations";

import { instance } from "@/lib/axios/instance";

export interface UseClientWebhookRegistrationsInfiniteParams {
  clientId?: string | null;
  excludeId?: string | null;
}

export function useClientWebhookRegistrationsInfinite({
  clientId,
  excludeId,
}: UseClientWebhookRegistrationsInfiniteParams = {}) {
  return useInfiniteQuery<PaginatedWebhookRegistrationsResponse, AxiosError>({
    queryKey: recruitNowWebhookQueryKeys.clientRegistrationsInfinite(clientId, excludeId),
    enabled: !!clientId,
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      instance
        .get<PaginatedWebhookRegistrationsResponse>(
          `/api/v2/Webhooks/RecruitNow/Clients/${clientId}/Registrations`,
          {
            params: {
              page: pageParam,
              pageSize: 10,
            },
          }
        )
        .then((res) => ({
          ...res.data,
          // Filter out the excluded ID from each page
          items: excludeId ? res.data.items.filter((item) => item.id !== excludeId) : res.data.items,
        })),
    getNextPageParam: (lastPage, allPages) => {
      const totalRecords = lastPage.totalCount;
      const totalFetched = allPages.reduce(
        (acc, page) => acc + page.items.length,
        0
      );
      return totalFetched < totalRecords ? allPages.length + 1 : undefined;
    },
    placeholderData: keepPreviousData,
  });
}
